// WHY: BE は RFC 6266 の filename* (UTF-8) と filename の両方、または filename のみを返し得る。
// filename* を優先し、無ければ filename（引用符あり/なし）を読む。取得できなければ null を返し、
// 呼び出し側でデフォルトファイル名にフォールバックする。
export const parseContentDispositionFilename = (
  contentDisposition: string | null | undefined
): string | null => {
  if (!contentDisposition) return null

  const extendedMatch = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(contentDisposition)
  if (extendedMatch?.[1]) {
    try {
      return decodeURIComponent(extendedMatch[1].trim().replace(/^["']|["']$/g, ''))
    } catch {
      // decode に失敗した場合は素通しの filename にフォールバック
    }
  }

  const basicMatch = /filename="?([^";]+)"?/i.exec(contentDisposition)
  if (basicMatch?.[1]) {
    return basicMatch[1].trim()
  }

  return null
}
